import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { errorSelector } from "../../state/slice/appStateSlice";
import { RootState } from "../../state/store";

export const useError = (componentId: string) => {
  const { error } = useSelector((state: RootState) => {
    return {
      error: errorSelector(state, componentId),
    };
  });
  return error;
};

export const Error = ({
  componentId,
  errorString,
}: {
  componentId: string;
  errorString?: string;
}) => {
  const error = useError(componentId);
  const { t } = useTranslation();

  // If error looks like a translation key (contains dots), translate it
  const displayError = error && error.includes(".") ? t(error, error) : error;

  return (
    <>
      {error && error !== "" && (
        <span className="text-red-500">{errorString ? errorString : displayError}</span>
      )}
    </>
  );
};
